export interface ExternalState {}

export enum TwilioChannelType {
  Sms = "sms",
  Email = "email",
}
